(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvTagsView', drvTagsView);

    drvTagsView.$inject = [];

    /**
     * Show the list of tags in a user friendly format
     *
     * # Scope Properties
     * {array} tags - Tags to be shown
     */
    function drvTagsView() {
        var directive = {
            restrict: 'E',
            scope: {},
            controller: function () { },
            controllerAs: 'drvCtrl',
            bindToController: {
                tags: '<'
            },
            template:
                '<div layout="row" layout-wrap>' +
                '   <span class="tag-chip" ng-repeat="tag in drvCtrl.tags" ng-style="{\'color\': tag.ForegroundColour, \'background-color\': tag.BackgroundColour}">' +
                '       {{tag.Name}}' +
                '   </span>' +
                '</div>'
        };
        return directive;
    }
})();